import api from '@/api'

export default {
  fetch () {
    return api.get('/users/me')
  },

  fetchProfile () {
    return api.get('/users/me/profile')
  },

  getToken () {
    return api.get('/users/me/connection')
  },

  refreshToken () {
    return api.post('/oauth/token', {grant_type: 'refresh_token', refresh_token: localStorage.getItem('refreshToken')})
  },

  sendToken (token) {
    return api.post('/users/me/connection', {token: token})
  },

  signIn (credentials) {
    return api.post('/oauth/token', {grant_type: 'password', username: credentials.email, password: credentials.password})
  },

  signOut () {
    return api.post('/oauth/revoke', {token: localStorage.getItem('oauthToken')})
  }
}
